import React, { useEffect } from 'react';
import { useProjectContext } from '~/hooks';
import { Header } from 'semantic-ui-react';
import { PricingType, PricingEstimateAutopricing } from '~/constants';
import SavingsAnalysisTable from '../SavingsAnalysis/SavingsAnalysisTable';
import PricingEstimateQuoteButton from './PricingEstimateQuoteButton';
import { ReactComponent as ConductorLogo } from '~/assets/logo.svg';
import PricingEstimateTooltip from '~/features/projectReview/components/PricingEstimate/PricingEstimateTooltip';
import { usePermissions } from '~/requests/permissions/usePermissions';

import '../styles.scss';

export default function PricingEstimateQuoteTable() {
  const { project, projectAutopricing } = useProjectContext();
  const { permissions } = usePermissions();
  const [isPriceEstimateStale, setIsPriceEstimateStale] = React.useState(false);

  useEffect(() => {
    if (project) {
      setIsPriceEstimateStale(!!(project.priceEstimateTimestamp && project.priceEstimateTimestamp < project.updatedAt));
    }
  }, [project.priceEstimateTimestamp, project.updatedAt]);

  return (
    <div className="pricing-estimate-container">
      <div className="card">
        <Header as="h2">
          Pricing estimate
          <PricingEstimateTooltip />
        </Header>
        <div className="pricing-estimate">
          {PricingEstimateAutopricing[project?.pricingType]?.map(({ label, valueKey }) => (
            <div key={`${project?.pricingType}-${label}`} className="estimate-item">
              <span className="estimate-value">{projectAutopricing?.autopricingResult?.[valueKey]}</span>
              <span className="estimate-label">{label}</span>
            </div>
          ))}
          <PricingEstimateQuoteButton isPriceEstimateStale={isPriceEstimateStale} />
          {permissions.isAdmin && project?.autopricingResult?.spreadsheetUrl && (
            <div className="admin-spreadsheet-link" style={{ marginTop: '12px', marginBottom: '12px', fontSize: '14px' }}>
              <a
                href={project.autopricingResult.spreadsheetUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                View pricing spreadsheet
              </a>
            </div>
          )}
          <div className="powered-by">
            <span>Powered by</span> <ConductorLogo />
          </div>
        </div>

      </div>
      {project?.pricingType === PricingType.OFFTAKE &&
        <div className="card">
          <SavingsAnalysisTable isPriceEstimateStale={isPriceEstimateStale} />
        </div>
      }
    </div>
  );
}